import cloneDeep from 'lodash/cloneDeep'

import {
  UPDATE_RETAILER,
  REPLACE_RETAILER,
  UPLOAD_COMPANY_LOGO_RESPONSE,
  UPLOAD_COMPANY_LOGO_SCANNING,
  UPLOAD_COMPANY_LOGO_SCAN_FAILED,
} from 'actions/actionTypes'

const mergeTokens = (held = [], incoming) =>
  incoming.map((token) => ({
    ...held.find(
      ({ mulberry_public_token }) =>
        mulberry_public_token === token.mulberry_public_token
    ),
    ...token,
  }))

export default (state = {}, action) => {
  switch (action.type) {
    case UPDATE_RETAILER:
      return {
        ...state,
        ...action.retailer,
        ...(action.retailer?.tokens && {
          tokens: mergeTokens(state.tokens, action.retailer.tokens),
        }),
      }

    case REPLACE_RETAILER:
      return {
        ...state,
        ...action.retailer,
      }

    // `logo_scan_pending` is client-only: core answers 202 while GuardDuty
    // scans an upload, and the flag keeps the preview in its scanning state
    // until the scan publishes the logo (RESPONSE) or ends any other way:
    // rejected, failed, or we stopped waiting (SCAN_FAILED).
    case UPLOAD_COMPANY_LOGO_SCANNING:
      return { ...state, logo_scan_pending: true }

    case UPLOAD_COMPANY_LOGO_SCAN_FAILED:
      return { ...state, logo_scan_pending: false }

    case UPLOAD_COMPANY_LOGO_RESPONSE: {
      const retailer = cloneDeep(state)
      retailer.settings.has_logo = true
      retailer.logo_scan_pending = false
      return { ...retailer }
    }

    default:
      return state
  }
}
